<template>
	<el-aside :style="{ width: asideWidth + 'px' }">
		<div class="aside_box">
			<div class="top_box">
				<div v-if="isLoad" class="top_el" :class="nowIndex ? '' : 'actived'" @click="homeCheck">
					<img src="../assets/img/index/icon_9.webp" />
					<span v-show="asideWidth == 300 && isLoad">&ensp;My Tasks</span>
				</div>
				<div class="nav_icon">
					<van-icon name="wap-nav" size="24" @click="checkWidth" />
				</div>
			</div>
		
			<div v-show="asideWidth == 300 && isLoad" class="bot_box">
				<div style="height: 100%; overflow: auto; padding-bottom: 150px">
					<el-menu :default-active="nowIndex" class="el-menu-vertical-demo">
		
						<!-- Document Control -->
						<el-submenu index="2" v-if="is_file == 1 || documents == 1">
							<template slot="title">
								<span>Document Control</span>
							</template>
		
							<el-menu-item-group>
		
								<el-menu-item
									index="2-1"
									@click="goUrl('/DocControl/changeRequest', '2-1')"
									v-if="documents == 1">
									Submit Change Request
								</el-menu-item>
		
								<el-menu-item
									index="2-2"
									@click="goUrl('/DocControl/documentsSearch', '2-2')"
									v-if="is_file == 1 || documents == 1">
									Search Documents
								</el-menu-item>
		
								<el-menu-item
									index="2-3"
									@click="goUrl('/DocControl/changeRequestSearch', '2-3')"
									v-if="is_file == 1 || documents == 1">
									Search Change Requests
								</el-menu-item>
		
								<el-menu-item
									index="2-5"
									@click="goUrl('/DocControl/configureDocControl', '2-5')"
									v-if="documents == 1">
									Configure Document Control
								</el-menu-item>
		
							</el-menu-item-group>
						</el-submenu>
		
						<!-- Training Management -->
						<el-submenu index="3" v-if="is_train == 1 || train == 1">
							<template slot="title">
								<span>Training Management</span>
							</template>
		
							<el-menu-item-group>
		
								<el-menu-item
									index="3-4"
									@click="goUrl('/TrainControl/train-index', '3-4')"
									v-if="is_train == 1 || train == 1">
									My Training
								</el-menu-item>
		
								<el-menu-item
									index="3-6"
									@click="goUrl('/TrainControl/train-search', '3-6')"
									v-if="is_train == 1 || train == 1">
									Search Training Records
								</el-menu-item>
		
								<el-menu-item
									index="3-9"
									@click="goUrl('/TrainControl/archival-search', '3-9')"
									v-if="is_train == 1 || train == 1">
									Search Training Archives
								</el-menu-item>
		
								<el-menu-item
									index="3-8"
									@click="goUrl('/TrainControl/general-search', '3-8')"
									v-if="is_train == 1 || train == 1">
									Search General Training Items
								</el-menu-item>
		
								<el-menu-item
									index="3-7"
									@click="goUrl('/TrainControl/effective-search', '3-7')"
									v-if="is_train == 1 || train == 1">
									Search Training Effectiveness Records
								</el-menu-item>
		
								<el-menu-item
									index="3-5"
									@click="goUrl('/TrainControl/train-manage', '3-5')"
									v-if="train == 1">
									Manage Training
								</el-menu-item>
		
								<el-menu-item
									index="3-1"
									@click="goUrl('/TrainControl/train-config', '3-1')"
									v-if="train == 1">
									Configure Training
								</el-menu-item>
		
								<el-menu-item
									index="3-3"
									@click="goUrl('/TrainControl/record-index', '3-3')"
									v-if="train == 1">
									Configure Training Archives
								</el-menu-item>
		
								<el-menu-item
									index="3-2"
									@click="goUrl('/TrainControl/general-index', '3-2')"
									v-if="train == 1">
									Configure General Training Items
								</el-menu-item>
		
							</el-menu-item-group>
						</el-submenu>
		
						<!-- CAPA -->
						<el-submenu index="4" v-if="is_capa == 1 || capa == 1">
							<template slot="title">
								<span>CAPA Management</span>
							</template>
		
							<el-menu-item-group>
		
								<el-menu-item
									index="4-2"
									@click="goUrl('/CapaControl/editCapaRequest', '4-2')"
									v-if="capa == 1">
									Submit CAPA Request
								</el-menu-item>
		
								<el-menu-item
									index="4-3"
									@click="goUrl('/CapaControl/searchRequest', '4-3')"
									v-if="is_capa == 1 || capa == 1">
									Search CAPA Requests
								</el-menu-item>
		
								<el-menu-item
									index="4-1"
									@click="goUrl('/CapaControl/configureCapa', '4-1')"
									v-if="capa == 1">
									Configure CAPA
								</el-menu-item>
		
							</el-menu-item-group>
						</el-submenu>
		
						<!-- System -->
						<el-submenu index="1" v-if="users == 1 || system == 1">
							<template slot="title">
								<span>System Administration</span>
							</template>
		
							<el-menu-item-group>
		
								<el-menu-item
									index="1-1"
									@click="goUrl('/system/user', '1-1')"
									v-if="system == 1 || users == 1">
									User Management
								</el-menu-item>
		
								<!-- <el-menu-item
									index="1-2"
									@click="goUrl('/system/company', '1-2')"
									v-if="system == 1">
									Company Management
								</el-menu-item> -->
		
								<el-menu-item
									index="1-3"
									@click="goUrl('/system/department', '1-3')"
									v-if="system == 1">
									Department Management
								</el-menu-item>
		
								<el-menu-item
									index="1-4"
									@click="goUrl('/system/role', '1-4')"
									v-if="system == 1">
									Role Management
								</el-menu-item>
		
								<el-menu-item
									index="1-5"
									@click="goUrl('/system/config', '1-5')"
									v-if="system == 1">
									Permission Configuration
								</el-menu-item>
		
							</el-menu-item-group>
						</el-submenu>
		
					</el-menu>
				</div>
			</div>
		</div>
	</el-aside>
</template>

<script>
	export default {
		components: {},
		data() {
			return {
				isLoading: true,
				asideWidth: 300,
				//侧边栏宽度
				isLoad: true,
				//侧边收缩/折叠文字展示
				is_config: localStorage.getItem("is_config"),
				is_file: localStorage.getItem("is_file"),
				is_train: localStorage.getItem("is_train"),
				is_capa: localStorage.getItem("is_capa"),
				system: localStorage.getItem("system"),
				users: localStorage.getItem("users"),
				capa: localStorage.getItem("capa"),
				documents: localStorage.getItem("documents"),
				train: localStorage.getItem("train"),
				nowIndex: sessionStorage.getItem("nowIndex") ? sessionStorage.getItem("nowIndex") : null
			};
		},
		created() {
			let that = this;
		},
		mounted() {
			let that = this;
			that.isLoading = false;
		},
		watch: {
			//
		},
		methods: {
			goUrl(url, value) {
				let that = this;
				if (that.$route.path != url) {
					sessionStorage.setItem("nowIndex", value);
					that.$router.push({
						path: url
					});
				}
			},
			//跳转我的任务
			homeCheck() {
				let that = this;
				if (that.$route.path != "/task-list") {
					sessionStorage.removeItem("nowIndex");
					that.$router.push({
						path: "/task-list"
					});
				}
			},
			//更改侧边栏宽度
			checkWidth() {
				let that = this;
				that.isLoad = false;
				if (that.asideWidth == 300) {
					that.asideWidth = 50;
				} else {
					that.asideWidth = 300;
					setTimeout(() => {
						that.isLoad = true;
					}, 200);
				}
			},
		},
	};
</script>

<style lang="less">
	//侧边栏
	.aside_box {
		height: calc(100vh - 65px);
		overflow: hidden;
		border-right: 1px solid #e5e5e5;
		padding: 20px 0;

		.bot_box {
			height: 100%;
			padding: 12px 0px 0 0px;

			.tree_box {
				overflow: auto;
			}
		}

		.top_box {
			display: flex;
			align-items: center;
			padding: 0 12px;

			.top_el {
				flex: 1;
				margin-right: 10px;
				padding: 4px 12px;
				border-radius: 10px;
				cursor: pointer;

				span {
					position: relative;
					top: 6px;
					font-size: 14px;
				}

				img {
					width: 28px;
				}
			}

			.nav_icon {
				width: 24px;
				height: 24px;
				cursor: pointer;
			}

			.top_el.actived {
				background-color: #ebf7ff;
				color: #4886ff;
			}
		}
	}
</style>
<style scoped>
	.el-header,
	.el-main {
		padding: 0;
	}

	.el-aside {
		transition: width 0.3s linear;
	}

	.el-menu {
		border-right: none;
	}
</style>